import { MainSource } from '../../../../constants/Source';
import { MediaManagerSDKFile } from '../../../media-manager-sdk';

export enum MediaProducer {
  ShutterStock = 'shutterStock',
  WixStock = 'wixStock',
}

export interface IWithPurchaseAnalyticsOuter {}

export interface IWithPurchaseAnalyticsInner {
  trackMediaManagerMediaPurchaseCompleted: (options: {
    item: MediaManagerSDKFile;
    category: string;
    mediaProducer: MediaProducer;
    source?: MainSource;
  }) => void;
}
